import type React from 'react';

// 이용약관/개인정보처리방침 공용 스타일 (한/영 공용)
export const wrap: React.CSSProperties = {
  maxWidth: '900px', margin: '0 auto', padding: '40px 20px',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
};
export const h1: React.CSSProperties = { fontSize: '32px', marginBottom: '10px', color: '#333' };
export const dateLine: React.CSSProperties = { color: '#666', marginBottom: '10px' };
export const section: React.CSSProperties = { marginBottom: '30px' };
export const h2: React.CSSProperties = { fontSize: '20px', color: '#333', marginBottom: '15px' };
export const p: React.CSSProperties = { lineHeight: '1.8', color: '#555' };
export const ul: React.CSSProperties = { lineHeight: '2', color: '#555', paddingLeft: '20px' };
export const footerWrap: React.CSSProperties = {
  marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #eee', textAlign: 'center',
};

// 상단 언어 토글 (이 두 페이지는 NavBar가 숨겨져 있어 자체 토글 필요)
export const langToggleBar: React.CSSProperties = {
  display: 'flex', justifyContent: 'flex-end', marginBottom: '10px',
};
export const langToggleBtn: React.CSSProperties = {
  padding: '5px 12px', borderRadius: 7, fontSize: 12, fontWeight: 700,
  background: '#f3f4f6', color: '#374151',
  border: '1px solid #e5e7eb', cursor: 'pointer', fontFamily: 'inherit',
};
